import styled from 'styled-components';

export const ShareholdersWrapper = styled('section')`
  padding-bottom: ${({ theme }) => theme.x1spacePx}px;
`;
